export const SET_HOTEL_LABELS = 'SET_HOTEL_LABELS';
export const UPDATE_HOTEL_LABELS = 'UPDATE_HOTEL_LABELS';
export const SET_METAPOLICIES = 'SET_METAPOLICIES';
export const UPDATE_METAPOLICIES = 'UPDATE_METAPOLICIES';
